import angular from 'angular';

import ManageCategoryComponent from './manage-category.component';

const ManageCategoryModule = angular
    .module('control-room.commons.content.components.manage-category', [])
    .component('crManageCategory', ManageCategoryComponent);

export default ManageCategoryModule;
